import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Observable, Subscription } from 'rxjs';

import { CurrentUser } from "../../common/providers/current-user";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { Organization } from "../../common/models/organization";
import { Athlete } from "../../common/models/athlete";
import { HttpEventType, HttpResponse } from "@angular/common/http";

@Injectable({providedIn: 'root'})
export class DocumentUploadService implements OnDestroy {

    private subscriptions: Subscription[] = [];

    constructor(
        private currentUser: CurrentUser,
        private api: ApiBaseService
    ) {}

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public upload(
        organization: Organization,
        athlete: Athlete,
        files: Set<File>,
    ): { [key: string]: { observable: Observable<number> } } {
        // this will be the our resulting map
        const status: { [key: string]: { observable: Observable<any> } } = {};
        const url = `organizations/${organization.code}/athletes/${athlete.userId}/documents/upload`;

        files.forEach((file) => {
            // create a new progress-subject for every file
            const progress = new Subject<any>();

            const fd = new FormData();
            fd.append('file', file, file.name);

            this.subscriptions.push(
                this.api.call('post',url, fd, this.currentUser.getAccessToken()).subscribe({
                    next: () => {
                        progress.next({percent: 100, errors: []});
                        progress.complete();
                    },
                    error: (err) => {
                        progress.next({percent: 0, errors: err.error ? err.error.errors : err.errors});
                        progress.complete();
                    }
                }),
            );

            // Save every progress-observable in a map of all observables
            status[file.name] = {
                observable: progress.asObservable()
            };
        });

        return status;
    }
}
